import Track from '../../../utils/tracking';

const validateContactNumberForFrasersPlus = (contactNumber) => {
  try {
    if (!contactNumber) {
      return false;
    }
    const regex = /^(?:(?:\+44|0044|440|447|0)?\s?7\d{3}\s?\d{6}|\+?44\s?07\d{3}\s?\d{6}|\+?44\s?7\d{3}\s?\d{6}|00\s?44\s?07\d{3}\s?\d{6}|00\s?44\s?7\d{3}\s?\d{6}|\+?44\s?4407\d{3}\s?\d{6}|447\d{9})$/;
    return regex.test(contactNumber);
  } catch (e) {
    Track.error(`Error matching regex to determine if contact number valid for Frasers Plus, returning true to not block order placement attempt: ${e}`);
    return true;
  }
};

export default validateContactNumberForFrasersPlus;
